import * as CustomYup from 'yup'
import { isAValidRut } from '../is-a-valid-rut'

CustomYup.addMethod(CustomYup.string, 'rut', function () {
  return this.test('rut-check-digit', '', function (value) {
    const { path, createError } = this

    return (
      isAValidRut(value) ||
      createError({ path, message: 'El RUT no es válido.' })
    )
  })
})

export { CustomYup }
